/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from 'react'
//import useStateContext from '../hooks/useStateContext'
import { useLocation } from "react-router-dom";
import { BASE_URL, createAPIEndpoint, ENDPOINTS } from '../api/index';
import { Typography, List, ListItemButton, Box, LinearProgress, Card, CardContent, CardActions, CardMedia, CardHeader, Button, Alert } from '@mui/material';
import { getFormatedTime } from '../helper/index.js';
import { useNavigate } from "react-router-dom";

export default function Quiz() {
    const location = useLocation();
    const navigate = useNavigate();
    //const { context, setContext } = useStateContext();
    const [qns, setQns] = useState([]);
    const [qnIndex, setQnIndex] = useState(0);
    const [timeTaken, setTimeTaken] = useState(0);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState({ qId: 1000, qsel: 1000 });

    let timer;


    const startTimer = () => {
        // console.log('start Timer');
        timer = setInterval(() => {
            setTimeTaken(prev => prev + 1);
        }, [1000])
    }
    useEffect(() => {
        if (location.state === null) { navigate("/") };
        createAPIEndpoint(ENDPOINTS.question)
            .fetch()
            .then(res => {
                setQns(res.data);
                //console.log(res.data);
                startTimer();
            })
            .catch(err => { console.log(err); })

        return () => { clearInterval(timer) }
    }, [])
    //console.log("login data",location.state.values)

    const updateAnswer = (qnId, optionIdx) => {
        const options = [...selectedOptions];
        setSelectedIndex({
            ...selectedIndex,
            qId: qnId,
            qsel: optionIdx
        });
        //console.log(selectedIndex);
        options.map((item, index) => {
            if (item.qnId === qnId) {
                options.splice(index, 1);
                //options.filter(a => a.qnId !== options.qnId)
                //console.log("splice:",options)
            }
        })
        options.push({
            qnId,
            selected: optionIdx
        })
        //console.log("temp", options);
        setSelectedOptions(...[options]);
        //console.log("options", selectedOptions)

        //if (qnIndex < qns.length-1) {
        //    setQnIndex(qnIndex + 1);
        //} else {
        //setTimeTaken(timeTaken);
        //console.log("time", timeTaken);
        //setSelectedOptions(temp);
        //console.log("options", selectedOptions)
        //navigate Result Component
        //navigate("/result", { state: { options: options, values: location.state.values, candidateid:location.state.participantid, time:timeTaken } })
        //}
    }

    const getPrevious = () => {
        setQnIndex(qnIndex - 1);
        setSelectedIndex({
            ...selectedIndex,
            qId: 1000,
            qsel: 1000
        });
        //console.log("reset", selectedIndex);
        selectedOptions.map((v, w) => {
            if (v.qnId === qns[qnIndex-1].qnId) {
                setSelectedIndex({
                    ...selectedIndex,
                    qId: v.qnId,
                    qsel: v.selected
                });
               // console.log(selectedIndex);
            }
        })

    }

    const getNext = () => {
        setQnIndex(qnIndex + 1);
        setSelectedIndex({
            ...selectedIndex,
            qId: 1000,
            qsel: 1000
        });
      //  console.log("reset", selectedIndex);
        selectedOptions.map((m, k) => {
            if (m.qnId === qns[qnIndex+1].qnId) {
                setSelectedIndex({
                    ...selectedIndex,
                    qId: m.qnId,
                    qsel:m.selected
                });
              //  console.log(selectedIndex);
            } 
        })
    }

    const submitQuiz = () => {
        setTimeTaken(timeTaken);
        navigate("/result", { state: { options: selectedOptions, values: location.state.values, candidateid: location.state.participantid, time: timeTaken } })
    }

    return (
        qns.length !== 0 
            ? <Card sx={{
                maxWidth: 640, mx: 'auto', mt: 1, mb: 1,
                '& .MuiCardHeader-action': { m: 0, alignSelf: 'center' }
            }}>
                <CardHeader
                    title={'Question ' + (qnIndex + 1) + ' of ' +  qns.length }
                    action={<Typography>{getFormatedTime(timeTaken)}</Typography>}/>
                <Box>
                    <LinearProgress variant="determinate" value={(qnIndex+1)*100/qns.length}/>
                </Box>
                {qns[qnIndex].imageName !== null
                    ? <CardMedia
                        component="img"
                        image={BASE_URL + 'Images/' + qns[qnIndex].imageName}
                        sx={{width:'auto', m:'10px auto'}} />
                        :null}
                <CardContent>
                    <Typography variant="h6">
                        {qns[qnIndex].qnInWords }
                    </Typography>
                    <List dense={true} disablePadding={true}>
                        {qns[qnIndex].options.map((item, idx) =>
                            <ListItemButton disableRipple key={idx} onClick={() => updateAnswer(qns[qnIndex].qnId, idx)} selected={selectedIndex.qsel === idx}>
                                {item !== null ?
                                    <div>
                                        <b>{String.fromCharCode(65 + idx) + " . "}</b>{item}
                                    </div>
                                    : null} 
                            </ListItemButton>
                        )}
                    </List>
                </CardContent>
                <CardActions sx={{mt:'15px'} }>
                    {qnIndex > 0 ? <Button size="small"
                        onClick={() => getPrevious()}>Previous</Button> : null}
                    {qnIndex < qns.length - 1 ? <Button size="small"
                        onClick={() => getNext()}>Next</Button> : null}
                    <Button size="small" onClick={() => submitQuiz()}>Done</Button>
                </CardActions>
            </Card>
            :null
    )
}